export default function Checkbox(theme) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius / 2,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&.Mui-checked': {
            color: theme.palette.primary.main,
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: theme.spacing(1),
        },
        label: {
          userSelect: 'none',
        },
      },
    },
  };
}

